import ProductCard from '@components/product/product-card-v2';
import Button from '@components/ui/button';
import type { FC } from 'react';
import ProductFeedLoader from '@components/ui/loaders/product-feed-loader';
import { useTranslation } from 'next-i18next';
import { Product, ProductPaginator } from '@type/index';
import isEmpty from 'lodash/isEmpty';
import { FilterQueryTags } from '@components/shop/filter-query-tags';
import NotFound from '@components/404/not-found';
interface ProductGridProps {
  className?: string;
  loading: boolean;
  data: any;
  hasNextPage: boolean | undefined;
  loadingMore: any;
  fetchNextPage: () => void;
  singleColumn?: boolean;
  hasFilterTags?: boolean;
}

export const ProductInfiniteGrid: FC<ProductGridProps> = ({
  className = '',
  loading,
  data,
  hasNextPage,
  loadingMore,
  fetchNextPage,
  singleColumn = false,
  hasFilterTags = true,
}) => {
  const { t } = useTranslation();

  // If no product found
  if (!loading && isEmpty(data?.pages?.[0].data)) {
    return (
      <>
        <FilterQueryTags />
        <NotFound text={t('text-no-products-found')} />
      </>
    );
  }

  return (
    <div className="flex flex-col">
      {hasFilterTags && <FilterQueryTags />}
      <div
        style={{
          rowGap: 'clamp( 20px, 3vw, 40px )',
          columnGap: 'clamp( 20px, 3vw, 40px )',
        }}
        className={`grid ${
          singleColumn
            ? 'grid-cols-1'
            : 'grid-cols-2 md:grid-cols-2 lg:grid-cols-3'
        }  py-5 ${className}`}
        //gap-x-3 md:gap-x-4 lg:gap-x-5 gap-y-3 md:gap-y-4 lg:gap-y-5
      >
        {loading && !data?.pages?.length ? (
          <ProductFeedLoader limit={20} uniqueKey="search-product" />
        ) : (
          data?.pages?.map((page: ProductPaginator) => {
            return (page?.data || [])?.map((product: Product) => (
              <ProductCard
                key={`product--key${product.id}`}
                product={product}
              />
            ));
          })
        )}
      </div>
      <div className="py-6 text-center md:pt-8 lg:pt-12">
        {hasNextPage && (
          <Button
            loading={loadingMore}
            disabled={loadingMore}
            onClick={() => fetchNextPage()}
            variant="slim"
          >
            {t('button-load-more')}
          </Button>
        )}
      </div>
    </div>
  );
};

export default ProductInfiniteGrid;
